/**
 * Shared Liberty admin UI tokens — matches PageHeader, CompanyEdit, Yardi invite, Transfer.
 */
export const LIBERTY_FOCUS_INPUT =
  "focus:outline-none focus:ring-2 focus:ring-[rgb(21_151_255)]/15 focus:border-[rgb(21_151_255)]"
